import React from 'react'
import { connect } from 'react-redux'

import { CircularProgress } from '../../shared/NarusMaterial'

import * as Actions from './actions'
import Narrative from './components/narrative'

class ClinicalImpressions extends React.Component {
  componentDidMount () {
    let { dispatch, params } = this.props

    dispatch(Actions.getNarratives(params.id))
  }

  componentDidUpdate (prevProps, prevState) {
    const { dispatch, params } = this.props

    if (prevProps.params.id !== params.id) {
      dispatch(Actions.getNarratives(params.id, params.clientName))
    }
  }

  render () {
    let { clinicalImpressions: { roles, loading } } = this.props

    if (loading) {
      return (
        <div>
          <CircularProgress />
        </div>
      )
    }

    if (roles.length === 0) {
      return (
        <p style={{ color: '#d6d6d6' }}>There are no narratives to display.</p>
      )
    }

    return (
      <div>
        {roles.map((narrative, i) => (
          <Narrative
            key={i}
            narrative={narrative}
          />
        ))}
      </div>
    )
  }
}

const mapStateToProps = redux => ({
  clinicalImpressions: redux.narratives
})

export default connect(mapStateToProps)(ClinicalImpressions)
